import { render, staticRenderFns } from "./ShoppingBagIcon.vue?vue&type=template&id=aa858f2c&scoped=true&"
import script from "./ShoppingBagIcon.vue?vue&type=script&lang=ts&"
export * from "./ShoppingBagIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ShoppingBagIcon.vue?vue&type=style&index=0&id=aa858f2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa858f2c",
  null
  
)

export default component.exports